import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as schoolLinked from "lib/appserver/entityHeaders/schoolLinked";

export const Student = new Immutable.Record({
  ...schoolLinked.defaultProperties,
  firstName: undefined,
  lastName: undefined,
  misId: undefined,
  credits: undefined,
  top_up: undefined,
  external_cashless: undefined
}, "Student");

function buildStudentFromAppserver(rawStudent) {
  return Student({
    ...schoolLinked.appserverAdapter(rawStudent),
    firstName: rawStudent.first_name,
    lastName: rawStudent.last_name,
    misId: rawStudent.mis_id,
    credits: buildCreditsFromAppserver(rawStudent),
    top_up: buildTopupsFromAppserver(rawStudent),
    external_cashless: buildExternalCashlessFromAppserver(rawStudent)
  });
}

function buildCreditsFromAppserver(rawStudent) {
  return new Immutable.Map(rawStudent.credits).map(floatToMoney);
}

function buildTopupsFromAppserver(rawStudent) {
  return new Immutable.Map(rawStudent.top_up);
}

function buildExternalCashlessFromAppserver(rawStudent){
  return new Immutable.Map(rawStudent.external_cashless)
}

Student.fromAppserver = buildStudentFromAppserver;
export default Student;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/Student.js